module.exports = __webpack_public_path__ + "img/jr21.defae170.jpg";